import React, { Component } from 'react'
import { List } from 'antd'
import { observer } from 'mobx-react'

import { slugify } from '../libs/utils'

class Search extends Component {
  
  state = {
    loading: true,
    // documents: []
  }
  
  componentDidMount(){
    
    // console.log('this.props', this.props)
    
    var query = this.getQueryString()
    
    this.props.store.document.search(query)
    
    window.scrollTo(0, 0)

  }
  
  getQueryString(){

    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === 'query') {
            return decodeURIComponent(pair[1]);
        }
    }
    
    return ''

  }
  
  render() {

    return (
      <List
        itemLayout="horizontal"
        dataSource={this.props.store.document.results}
        bordered={true}
        renderItem={item => {

          var slug = slugify(item.title)

          return (
            <List.Item>
              <List.Item.Meta
                title={<a href={"/doc/"+item.id+"/"+slug}>{item.title}</a>}
              />
            </List.Item>
          )
          
        }}
      />
    );
    
  }
  
}

export default observer(Search);